(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('AlarmSettingsController', AlarmSettingsController);

    AlarmSettingsController.$inject = ['$scope', '$filter', 'AlarmService', 'OltService', 'OnuService', 'Authenticate', 'RequestService'];

    function AlarmSettingsController($scope, $filter, AlarmService, OltService, OnuService, Authenticate, RequestService) {
        var vm = this;

        // Requests
        vm.getAuthenticate = getAuthenticate;
        vm.getOlts = getOlts;
        vm.getOnus = getOnus;
        vm.getOltAlarmSettings = getOltAlarmSettings;
        vm.getOnuAlarmSettings = getOnuAlarmSettings;
        vm.save = save;

        // Comboboxes content
        vm.oltList = [];
        vm.onuList = [];
        vm.oltZhoneList = [];

        // Comboboxes actions
        vm.setOlt = setOlt;
        vm.setOnu = setOnu;

        // Actions
        vm.close = close;
        vm.clearModelOlt = clearModelOlt;
        vm.clearModelOnu = clearModelOnu;
        vm.disableDropdown = disableDropdown;
        vm.disableButton = disableButton;
        vm.changeLayout = changeLayout;
        vm.listenerSeverityCheck = listenerSeverityCheck;
        vm.setSeverityCheckModelDefault = setSeverityCheckModelDefault;
        vm.updateSeverityCheckModel = updateSeverityCheckModel;
        vm.updateRogueOption = updateRogueOption;
        vm.initialize = initialize;
        vm.toggleFilter = toggleFilter;
        function toggleFilter() {
            vm.open = !vm.open;
        }

        // Variables
        var requestRunning = false;
        vm.postRunning = false;
        var severityCheck = [];
        vm.dataSettings = {fields: {}};
        vm.interface = 'OLT';
        vm.isOptionOlt = true;
        vm.severityTypes = null;
        vm.rogueOptions = null;
        vm.authComponent = {olt: false, onu: false};
        vm.oltSelected = null;
        vm.onuSelected = null;
        vm.settingsModelOlt = {
            oltId: null,
            severity: [],
            maxTemperature: '',
            minTemperature: '',
            onuRogueGpon: {
                port1: '',
                port2: '',
                port3: '',
                port4: '',
                port5: '',
                port6: '',
                port7: '',
                port8: ''
            },
            portLinkDownSeverityGE1: {
                port1: {label: '', value: ''},
                port2: {label: '', value: ''},
                port3: {label: '', value: ''},
                port4: {label: '', value: ''},
                port5: {label: '', value: ''},
                port6: {label: '', value: ''},
                port7: {label: '', value: ''},
                port8: {label: '', value: ''}
            },
            portLinkDownSeverityGE10: {
                port1: {label: '', value: ''},
                port2: {label: '', value: ''}
            }
        };
        vm.settingsModelOnu = {
            oltId: null,
            onuId: null,
            linkDown: {label: '', value: ''},
            maxPower: '',
            minPower: ''
        };
        vm.placeholder = {
            olt: '',
            onu: ''
        };

        // Requests
        function getAuthenticate() {
            vm.authComponent.olt = Authenticate.hasPermission('oltAlarmConfig');
            vm.authComponent.onu = Authenticate.hasPermission('onuAlarmConfig');
            if (!vm.authComponent.olt && vm.authComponent.onu) {
                vm.interface = 'ONU';
                changeLayout(vm.interface);
            } else if (vm.authComponent.olt && !vm.authComponent.onu) {
                vm.interface = 'OLT';
                changeLayout(vm.interface);
            }
        }

        function getOlts() {
            requestRunning = true;
            vm.placeholder.olt = 'global.common.loading';
            OltService.listOlts(null, true).then(getOltSuccess).catch(getOltError);
        }

        function getOnus(oltId) {
            if (vm.authComponent.onu) {
                requestRunning = true;
                vm.placeholder.onu = 'global.common.loading';
                OnuService.getAuthorizedOnuList({oltId: oltId}, true).then(getOnuSuccess).catch(getOnuError);
            }
        }

        function getOltAlarmSettings(oltId) {
            requestRunning = true;
            AlarmService.getOltAlarmSettings(oltId)
                    .then(getOltAlarmSettingsSuccess)
                    .catch(getOltAlarmSettingsError);
        }

        function getOnuAlarmSettings(oltId, onuId) {
            requestRunning = true;
            AlarmService.getOnuAlarmSettings(oltId, onuId)
                    .then(getOnuAlarmSettingsSuccess)
                    .catch(getOnuAlarmSettingsError);
        }

        function save() {

            if (!vm.isOptionOlt) {
                if (parseInt(vm.settingsModelOnu.minPower) > parseInt(vm.settingsModelOnu.maxPower)) {
                    saveAlarmSettingsError({status: '400.1', config: {}});
                    vm.formAlarmSettings.maxPower.$setValidity('maxmin', false);
                    vm.formAlarmSettings.minPower.$setValidity('maxmin', false);
                } else {
                    vm.formAlarmSettings.maxPower.$setValidity('maxmin', true);
                    vm.formAlarmSettings.minPower.$setValidity('maxmin', true);
                }
            }

            if (vm.formAlarmSettings.$valid && !requestRunning && !vm.postRunning) {
                requestRunning = true;
                vm.postRunning = true;
                vm.settingsModelOlt.severity = severityCheck;
                if (vm.isOptionOlt) {
                    vm.settingsModelOlt.maxTemperature = parseInt(vm.settingsModelOlt.maxTemperature);
                    vm.settingsModelOlt.minTemperature = parseInt(vm.settingsModelOlt.minTemperature);
                    vm.settingsOlt = {
                        oltId: vm.oltSelected.id,
                        severity: vm.settingsModelOlt.severity,
                        maxTemperature: vm.settingsModelOlt.maxTemperature,
                        minTemperature: vm.settingsModelOlt.minTemperature,
                        onuRogueGpon: {
                            port1: vm.settingsModelOlt.onuRogueGpon.port1.toUpperCase(),
                            port2: vm.settingsModelOlt.onuRogueGpon.port2.toUpperCase(),
                            port3: vm.settingsModelOlt.onuRogueGpon.port3.toUpperCase(),
                            port4: vm.settingsModelOlt.onuRogueGpon.port4.toUpperCase(),
                            port5: vm.settingsModelOlt.onuRogueGpon.port5.toUpperCase(),
                            port6: vm.settingsModelOlt.onuRogueGpon.port6.toUpperCase(),
                            port7: vm.settingsModelOlt.onuRogueGpon.port7.toUpperCase(),
                            port8: vm.settingsModelOlt.onuRogueGpon.port8.toUpperCase()
                        },
                        portLinkDownSeverityGE1: {
                            port1: vm.settingsModelOlt.portLinkDownSeverityGE1.port1.value,
                            port2: vm.settingsModelOlt.portLinkDownSeverityGE1.port2.value,
                            port3: vm.settingsModelOlt.portLinkDownSeverityGE1.port3.value,
                            port4: vm.settingsModelOlt.portLinkDownSeverityGE1.port4.value,
                            port5: vm.settingsModelOlt.portLinkDownSeverityGE1.port5.value,
                            port6: vm.settingsModelOlt.portLinkDownSeverityGE1.port6.value,
                            port7: vm.settingsModelOlt.portLinkDownSeverityGE1.port7.value,
                            port8: vm.settingsModelOlt.portLinkDownSeverityGE1.port8.value
                        },
                        portLinkDownSeverityGE10: {
                            port1: vm.settingsModelOlt.portLinkDownSeverityGE10.port1.value,
                            port2: vm.settingsModelOlt.portLinkDownSeverityGE10.port2.value
                        }
                    };
                    AlarmService.saveOltAlarmSettings(vm.settingsOlt)
                            .then(saveAlarmSettingsSuccess)
                            .catch(saveAlarmSettingsError);
                } else {
                    vm.settingsOnu = {
                        oltId: vm.oltSelected.id,
                        onuId: vm.onuSelected.id,
                        linkDown: vm.settingsModelOnu.linkDown.value,
                        maxPower: parseInt(vm.settingsModelOnu.maxPower),
                        minPower: parseInt(vm.settingsModelOnu.minPower)
                    };
                    AlarmService.saveOnuAlarmSettings(vm.settingsOnu)
                            .then(saveAlarmSettingsSuccess)
                            .catch(saveAlarmSettingsError);
                }
            }
        }


        // Combo boxes actions
        function setOlt(olt) {
            if (requestRunning) {
                RequestService.cancelRequests('alarms');
                requestRunning = false;
            }

            if (vm.interface == 'OLT') {
                setSeverityCheckModelDefault();
                getOltAlarmSettings(olt.id);
            } else {
                if (vm.onuSelected) {
                    clearModelOnu();
                    vm.onuSelected = null;
                    vm.onuList = [];
                }
                getOnus(olt.id);
            }
        }

        function setOnu(onu) {
            if (requestRunning) {
                RequestService.cancelRequests('alarms');
                requestRunning = false;
            }
            clearModelOnu();
            getOnuAlarmSettings(vm.oltSelected.id, onu.id);
        }

        function setSeverityType() {
            vm.severityTypes = [
                {label: 'Disabled', value: 'NONE'},
                {label: 'Minor', value: 'MINOR'},
                {label: 'Major', value: 'MAJOR'},
                {label: 'Warning', value: 'WARNING'},
                {label: 'Critical', value: 'CRITICAL'}
            ];
        }

        function setRogueOptions() {
            vm.rogueOptions = [
                'none',
                'alarm',
                'shutdown'
            ];
            vm.dataSettings.fields.rogueOptions = vm.rogueOptions;
        }

        function clearModelOlt() {
            vm.settingsModelOlt = {
                oltId: null,
                severity: [],
                maxTemperature: '',
                minTemperature: '',
                onuRogueGpon: {
                    port1: '',
                    port2: '',
                    port3: '',
                    port4: '',
                    port5: '',
                    port6: '',
                    port7: '',
                    port8: ''
                },
                portLinkDownSeverityGE1: {
                    port1: {label: '', value: ''},
                    port2: {label: '', value: ''},
                    port3: {label: '', value: ''},
                    port4: {label: '', value: ''},
                    port5: {label: '', value: ''},
                    port6: {label: '', value: ''},
                    port7: {label: '', value: ''},
                    port8: {label: '', value: ''}
                },
                portLinkDownSeverityGE10: {
                    port1: {label: '', value: ''},
                    port2: {label: '', value: ''}
                }
            };
        }

        function clearModelOnu() {
            vm.settingsModelOnu = {
                oltId: null,
                onuId: null,
                linkDown: {},
                maxPower: '',
                minPower: ''
            };
        }

        function disableDropdown(type) {
            switch (type) {
                case 'OLT':
                    return !vm.oltSelected || !vm.oltSelected.id || requestRunning;
                case 'ONU':
                    return !vm.onuSelected || !vm.onuSelected.id || requestRunning;
            }
        }

        function disableButton(value) {
            return disableDropdown('OLT') || (severityCheck.length == 1 && vm.severityCheckModel[value]);
        }

        function changeLayout(type) {
            switch (type) {
                case 'OLT':

                    if (requestRunning) {
                        RequestService.cancelRequests('onus');
                        RequestService.cancelRequests('alarms');
                        requestRunning = false;
                    }

                    vm.isOptionOlt = true;
                    setSeverityCheckModelDefault();
                    clearModelOlt();

                    if (vm.oltList.length) {
                        vm.placeholder.olt = '';
                        vm.oltSelected = {};
                    } else {
                        vm.placeholder.olt = 'alarm.filter.placeholder.noOltFound';
                        vm.oltSelected = null;
                    }

                    break;

                case 'ONU':

                    if (requestRunning) {
                        RequestService.cancelRequests('alarms');
                        requestRunning = false;
                    }

                    vm.isOptionOlt = false;
                    clearModelOnu();

                    if (vm.oltList.length) {
                        vm.placeholder.olt = '';
                        vm.oltSelected = {};
                    } else {
                        vm.placeholder.olt = 'alarm.filter.placeholder.noOltFound';
                        vm.oltSelected = null;
                    }

                    vm.placeholder.onu = 'alarm.filter.placeholder.selectOlt';
                    vm.onuSelected = null;
                    vm.onuList = [];

                    break;
            }
        }

        function listenerSeverityCheck() {
            setSeverityCheckModelDefault();
            $scope.$watchCollection('vmAlarmSettings.severityCheckModel', function () {
                severityCheck = [];
                angular.forEach(vm.severityCheckModel, function (value, key) {
                    if (value) {
                        severityCheck.push(key.toUpperCase());
                    }
                });
            });
        }

        function setSeverityCheckModelDefault() {
            vm.severityCheckModel = {
                minor: false,
                major: false,
                warning: false,
                critical: false
            };
        }

        function updateSeverityCheckModel(data) {
            if (data.severity) {
                setSeverityCheckModelDefault();
                var severityArray = angular.copy(data.severity);
                angular.forEach(severityArray, function (element) {
                    var itemSeverity = element.trim().toLowerCase();
                    vm.severityCheckModel[itemSeverity] = true;
                });
            }
        }

        function updateRogueOption(data) {
            angular.forEach(vm.settingsModelOlt.onuRogueGpon, function (item, index) {
                vm.settingsModelOlt.onuRogueGpon[index] = $filter('filter')(vm.rogueOptions, data.onuRogueGpon[index])[0];
            });
        }

        function updateEthernetPort(data) {
            angular.forEach(vm.settingsModelOlt.portLinkDownSeverityGE1, function (item, index) {
                vm.settingsModelOlt.portLinkDownSeverityGE1[index] = $filter('filter')(vm.severityTypes, data.portLinkDownSeverityGE1[index])[0];
            });
        }

        function updateGEPort(data) {
            angular.forEach(vm.settingsModelOlt.portLinkDownSeverityGE10, function (item, index) {
                vm.settingsModelOlt.portLinkDownSeverityGE10[index] = $filter('filter')(vm.severityTypes, data.portLinkDownSeverityGE10[index])[0];
            });
        }

        function setTemperatureAndPowerValues() {
            var modelTemperatureAndPower = {
                maxTemperature: [],
                minTemperature: [],
                powerMaxAndMin: []
            };

            for (var i = -40; i <= 65; i++) {
                if (i <= 0) {
                    modelTemperatureAndPower.minTemperature.push(i.toString());
                    if (i >= -35) {
                        modelTemperatureAndPower.powerMaxAndMin.push(i.toString());
                    }
                }
                if (i >= 35 && i <= 65) {
                    modelTemperatureAndPower.maxTemperature.push(i.toString());
                }
            }
            vm.optionsTemperatureAndPowerValues = modelTemperatureAndPower;
        }

        // Request response
        function getOltSuccess(data) {
            requestRunning = false;
            vm.oltList = data;
            vm.oltZhoneList = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].model === 'OLT8820G') {
                    vm.oltZhoneList.push(data[i]);
                }
            }
            vm.placeholder.olt = data.length ? '' : 'alarm.filter.placeholder.noOltFound';
        }

        function getOltError(response) {
            requestRunning = false;
            AlarmService.errorModalConstructor(response, 'getOltList');
        }

        function getOnuSuccess(data) {
            requestRunning = false;
            vm.onuList = data;
            if (data.length) {
                vm.onuSelected = {};
                vm.placeholder.onu = '';
            } else {
                vm.onuSelected = null;
                vm.placeholder.onu = 'alarm.filter.placeholder.noOnuFound';
            }
        }

        function getOnuError(response) {
            requestRunning = false;
            AlarmService.errorModalConstructor(response, 'getOnuList');
        }

        function getOltAlarmSettingsSuccess(data) {
            data.maxTemperature = data.maxTemperature.toString();
            data.minTemperature = data.minTemperature.toString();
            requestRunning = false;
            vm.settingsModelOlt = data;
            updateSeverityCheckModel(data);
            updateRogueOption(data);
            updateEthernetPort(data);
            updateGEPort(data);
        }

        function getOltAlarmSettingsError(response) {
            if (!response.config.canceled) {
                vm.dataSettings.data = null;
                requestRunning = false;
                AlarmService.errorModalConstructor(response, 'getConfigurations');
                vm.oltSelected = {};
            }
        }

        function getOnuAlarmSettingsSuccess(data) {
            requestRunning = false;
            vm.settingsModelOnu.minPower = data.minPower.toString();
            vm.settingsModelOnu.maxPower = data.maxPower.toString();
            vm.settingsModelOnu.linkDown = $filter('filter')(vm.severityTypes, data.linkDown)[0];
        }

        function getOnuAlarmSettingsError(response) {
            if (!response.config.canceled) {
                vm.dataSettings.data = null;
                requestRunning = false;

                vm.oltSelected = {};

                vm.onuSelected = null;
                vm.onuList = [];
                vm.placeholder.onu = 'alarm.filter.placeholder.selectOlt';

                AlarmService.errorModalConstructor(response, 'getConfigurations');
            }
        }

        function saveAlarmSettingsSuccess(response) {
            requestRunning = false;
            vm.postRunning = false;
            AlarmService.successModalConstructor('saveConfigurations');
        }

        function saveAlarmSettingsError(response) {
            requestRunning = false;
            vm.postRunning = false;
            AlarmService.errorModalConstructor(response, 'saveConfigurations');
        }

        function initialize() {
            getAuthenticate();
            clearModelOlt();
            clearModelOnu();
            getOlts();
            listenerSeverityCheck();
            setTemperatureAndPowerValues();
            setSeverityType();
            setRogueOptions();
        }
        initialize();
    }
})();
